module.exports = {
  "customer": {
    customerInformation: "市场分布",
    searchHint: "客户名称/地址/销售人员",
    customerList: "客户列表",
    customerName: "客户名称",
    customerNameHint: "请输入客户名称",
    detailsAddress: "详细地址",
    detailsAddressHint: "请选择详细地址",
    customerType: "客户类型",
    customerTypeHint: "请选择客户类型",
    deleteHint: "删除该客户信息 {0} 将不可恢复，确定吗？",
    addCustomer: "新增客户信息",
    editCustomer: "编辑客户信息",
    viewCustomer: "查看客户信息"
  },
};


// WEBPACK FOOTER //
// ./src/i18n/customer/zh-CN.js